import React, { useState, useEffect, useRef } from 'react';
import Axios from 'axios';
import { useNavigate } from 'react-router-dom';

const key = 'dqweqwe123y97qhduiasd$@^!*#&bjasdja&^&@!#';

const I = {
  Search: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.35-4.35" />
    </svg>
  ),
  Person: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Book: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  Close: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M18 6 6 18M6 6l12 12" />
    </svg>
  ),
  ChevronDown: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="m6 9 6 6 6-6" />
    </svg>
  ),
};

const KIND_LABELS = {
  '1': 'Supplier / Service Provider',
  '2': 'Engineer / Workforce',
  '3': 'Info in EngInfo',
};

export const QuickSearch = (props) => {
  const history = useNavigate();
  const inputRef = useRef(null);
  const debounceRef = useRef(null);

  const [searchby, setSearchBy] = useState('1');
  const [query, setQuery] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(0);

  const open = !!props.open;

  // Reset state on close
  useEffect(() => {
    if (!open) {
      setQuery('');
      setOptions([]);
      setActive(0);
    } else {
      setTimeout(() => inputRef.current && inputRef.current.focus(), 50);
    }
  }, [open]);

  // Lock body scroll + Esc handler
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') props.closeqs && props.closeqs(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, props]);

  // Re-fetch when searchby changes
  useEffect(() => {
    if (!open || !query) return;
    fetchOptions(query, searchby);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchby]);

  const fetchOptions = (value, by = searchby) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!value) { setOptions([]); return; }
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await Axios.get('/new_apis/getquicksearch', {
          params: { search: value, searchby: by },
          headers: { key },
        });
        setOptions(res.data.data || []);
        setActive(0);
      } catch {
        setOptions([]);
      }
      setLoading(false);
    }, 220);
  };

  const onChange = (e) => {
    const v = e.target.value;
    setQuery(v);
    if (props.settext) props.settext(v);
    fetchOptions(v);
  };

  const onSelect = (item) => {
    if (!item) return;
    if (searchby === '1') {
      props.settext(item.name);
      history(`/psdetails/${item?.slug}/${item?.product_id}`);
    } else if (searchby === '2') {
      props.settext(item.fname);
      history(`/ewdetails/${item?.cat}/${item?.user_id}`);
    } else if (searchby === '3') {
      props.settext(item.title);
      history(`/eng-info/info-detail/${item?.slug}/${item?.id}`);
    }
    props.closeqs();
  };

  const onKeyDown = (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive((i) => Math.min(i + 1, options.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((i) => Math.max(i - 1, 0)); }
    else if (e.key === 'Enter' && options[active]) { e.preventDefault(); onSelect(options[active]); }
  };

  const renderRow = (option, isActive) => {
    let title; let sub; let IconCmp;
    if (searchby === '1') { title = option.name; sub = `${option.cat} · ${option.subcat}`; IconCmp = I.Person; }
    else if (searchby === '2') { title = `${option.fname} ${option.lname}`; sub = `${option.cat} · ${option.subcat}`; IconCmp = I.Person; }
    else { title = option.title; sub = option.parent; IconCmp = I.Book; }
    return (
      <>
        <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${isActive ? 'bg-amber/20 text-amber' : 'bg-surface-overlay/70 text-fg-tertiary'}`}>
          <IconCmp className="h-4 w-4" />
        </span>
        <span className="flex min-w-0 flex-1 flex-col">
          <span className={`truncate text-[13.5px] font-semibold ${isActive ? 'text-amber' : 'text-fg-primary'}`}>{title}</span>
          {sub && <span className="truncate text-[11px] text-fg-tertiary">{sub}</span>}
        </span>
      </>
    );
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[1300] flex items-start justify-center px-4 pt-[10vh]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="qs-title"
    >
      <button
        type="button"
        aria-label="Close"
        onClick={props.closeqs}
        className="absolute inset-0 bg-black/72 backdrop-blur-md animate-[fadeIn_180ms_ease-out]"
      />
      <div
        className="
          relative w-full max-w-[600px]
          rounded-2xl border border-amber/24 bg-surface-paper
          shadow-dialog
          animate-[fadeIn_220ms_ease-out]
          max-h-[80vh] overflow-hidden flex flex-col
        "
      >
        <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/60 to-transparent" />

        {/* Header + close */}
        <div className="flex items-start justify-between gap-3 px-5 pt-5 pb-3">
          <div className="min-w-0">
            <div className="mb-1 inline-flex items-center gap-1.5">
              <span aria-hidden className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber opacity-60" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-amber" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-amber">Quick search</span>
            </div>
            <h2 id="qs-title" className="text-[18px] font-bold tracking-[-0.018em] text-fg-primary">Find anything on ESAY</h2>
          </div>
          <button
            type="button"
            onClick={props.closeqs}
            aria-label="Close"
            className="
              inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full
              text-fg-tertiary
              transition-[background-color,color] duration-200
              hover:bg-surface-overlay hover:text-amber
            "
          >
            <I.Close className="h-4 w-4" />
          </button>
        </div>

        {/* Filter chips */}
        <div className="flex flex-wrap gap-1.5 px-5 pb-3 border-b border-border-subtle">
          {Object.entries(KIND_LABELS).map(([k, label]) => (
            <button
              key={k}
              type="button"
              onClick={() => setSearchBy(k)}
              className={`
                inline-flex items-center rounded-full px-3 py-1
                text-[10.5px] font-bold uppercase tracking-[0.12em]
                transition-[background-color,border-color,color] duration-200
                ${searchby === k
                  ? 'bg-amber text-ink border border-amber'
                  : 'border border-border-subtle text-fg-secondary hover:border-amber/40 hover:text-amber'}
              `}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Search input */}
        <div className="px-5 pt-3">
          <label
            className={`
              relative flex h-12 items-center gap-2 rounded-lg px-3
              bg-surface-overlay/70
              border
              transition-[border-color,background-color,box-shadow] duration-200 ease-out-soft
              focus-within:bg-surface-overlay
              focus-within:border-amber
              focus-within:shadow-[0_0_0_3px_rgba(251,191,36,0.18)]
              border-amber/30
            `}
          >
            <I.Search className="h-4 w-4 shrink-0 text-amber" />
            <input
              ref={inputRef}
              type="text"
              value={query}
              onChange={onChange}
              onKeyDown={onKeyDown}
              placeholder="Type a name or keyword"
              className="w-full bg-transparent text-[14.5px] font-medium text-fg-primary placeholder:text-fg-muted outline-none border-0 p-0 leading-none"
              autoComplete="off"
            />
            {loading && (
              <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0 animate-spin text-amber" aria-hidden>
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2.5" fill="none" strokeDasharray="40 60" strokeLinecap="round" />
              </svg>
            )}
          </label>
        </div>

        {/* Results */}
        <div className="flex-1 overflow-y-auto px-3 py-3">
          {!query && !loading && (
            <div className="px-2 py-6 text-center text-[12.5px] text-fg-tertiary">
              Start typing to search.
            </div>
          )}
          {query && !loading && options.length === 0 && (
            <div className="px-2 py-6 text-center text-[12.5px] text-fg-tertiary">
              No results found.
            </div>
          )}
          {options.map((option, i) => (
            <button
              key={i}
              type="button"
              onMouseEnter={() => setActive(i)}
              onClick={() => onSelect(option)}
              className={`
                flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left
                transition-[background-color] duration-150 ease-out-soft
                ${i === active ? 'bg-amber/10' : 'hover:bg-surface-overlay/40'}
              `}
            >
              {renderRow(option, i === active)}
            </button>
          ))}
        </div>

        {/* Footer hint */}
        <div className="hidden sm:flex items-center justify-end gap-3 px-5 py-2 border-t border-border-subtle bg-surface-overlay/30 text-[10.5px] text-fg-tertiary">
          <span><kbd className="rounded bg-surface-overlay/70 border border-border-subtle px-1.5 py-0.5 text-[9.5px] text-amber">↑</kbd> <kbd className="rounded bg-surface-overlay/70 border border-border-subtle px-1.5 py-0.5 text-[9.5px] text-amber">↓</kbd> navigate</span>
          <span><kbd className="rounded bg-surface-overlay/70 border border-border-subtle px-1.5 py-0.5 text-[9.5px] text-amber">↵</kbd> open</span>
          <span><kbd className="rounded bg-surface-overlay/70 border border-border-subtle px-1.5 py-0.5 text-[9.5px] text-amber">esc</kbd> close</span>
        </div>
      </div>
    </div>
  );
};
